<template>
  <div style="min-width:100%">
    <!-- <div style="width:100%;display: flex;padding:10px">
    
         <div @click="insert()" style="color:#0E5FD8;margin-left:20px;cursor: pointer;">新增特征值  </div>
       <div @click="handleToNextStep()" style="color:#0E5FD8;margin-left:20px;cursor: pointer;">刷新</div> 
    
    </div>   -->

        <div class="dome-table">
            <div class="dome-thead">
                 <div class="dome-tr dome-tr_head">
                     <div  class="dome-th dome-seq">#</div>
                     <div v-for="(i,n) in headListDB" :key="n">
                          <div class="dome-th" v-if="i.visible" :class="i.type=='boolean'?'dome-seq':''"> {{i.value}}</div>
                      </div>
                     <!-- <div class="dome-th">项目特征值</div>
                     <div class="dome-th">特征控件类型</div>
                     <div class="dome-th">特征值</div>
                     <div class="dome-th">操作</div> -->
                 </div>
            </div>
             <div>
                <el-checkbox-group v-model="checkList" v-if="rowList.length!=0" >
   
    <!-- <el-checkbox label="复选框 B"></el-checkbox>
    <el-checkbox label="复选框 C"></el-checkbox>
    <el-checkbox label="禁用" disabled></el-checkbox>
    <el-checkbox label="选中且禁用" disabled></el-checkbox> -->

                  <div v-for="(user,index) in rowList" :key="index" class="dome-tr" >
                      <div class="dome-td  dome-seq3" >{{index+1}}</div>
                       <div class="dome-td" v-for="(i,n) in user" :key="n" :class="i.type=='boolean'?'dome-seq2':''">
                         <div v-if="i.type=='boolean'&&i.visible">
                           <el-checkbox :disabled='i.enable' :checked='i.value=="true"' :label="index" @change="checked=>handleCheckedCitiesChange(checked,i.key,index)" :key="index"><br></el-checkbox>
                          </div>
                          <div v-else-if="i.type=='basedata'&&i.visible">
                              <div v-if="i.enable">{{i.value}}</div>
                              <el-input v-model="i.value" placeholder="请输入内容" class="dome-input" clearable @blur="saveData(index,n)"  v-else></el-input>
                          </div>
                          <div v-else-if="i.type=='text'&&i.visible">
                              <div v-if="i.enable">{{i.value}}</div>
                              <el-input v-model="i.value" placeholder="请输入内容" class="dome-input" clearable @blur="saveData(index,n)"  v-else></el-input>
                          </div>
                          <div v-else-if="i.type=='enum'&&i.visible">
                              <div v-if="i.enable">{{keyToLable(i.enumVal,i.value)}}</div>
                              <el-select v-model="i.value" placeholder="请选择" class="dome-input"  @change="changeType(index,n)" v-else>
                                <el-option
                                  v-for="item in i.enumVal"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key">
                                </el-option>
                              </el-select>
                          </div>
                          <div v-else-if="i.type=='number'&&i.visible">
                              <div v-if="i.enable">{{i.value}}</div>
                              <el-input  v-model="i.value" placeholder="请输入内容" class="dome-input" clearable @blur="saveData(index,n)" @input="checkNumber($event, index,n)" v-else></el-input>
                          </div>
                        <!-- <div v-else-if="i.type=='basedata'" style="display:flex" @click="f7click(index)">
                               <el-input v-model="i.value" placeholder="请选择" class="dome-input dome-input_F7" clearable ></el-input>
                               <i class="el-icon-search" style="color: blue;line-height: 32px;" v-if="!i.enable" ></i>
                        </div> -->
                         
                         <!-- <div v-if="i.type=='text'">
                           <el-input v-model="i.value" placeholder="请输入内容" class="dome-input" clearable @blur="saveData(index)"></el-input>
                        </div> -->
                       
                         <!-- <div v-if="i.type=='DATE'">
                          
                               <el-date-picker
                                v-model="i.value"
                                type="date"
                                @change="saveData(index)"
                                placeholder="选择日期"
                                 value-format="yyyy-MM-DD"
                                >
                              </el-date-picker>
                        </div>
                        <div v-if="i.type=='F7'" style="display:flex" @click="f7click(index)">
                          
                               <el-input v-model="i.value.name" placeholder="请选择" class="dome-input dome-input_F7" clearable ></el-input>
                               <i class="el-icon-search" style="color: blue;line-height: 32px;"></i>
                        </div> -->
                         <!-- <div v-if="i.type=='enum'">
                             <el-select v-model="i.value" placeholder="请选择" class="dome-input"   @change="saveData(index)">
                                <el-option
                                  v-for="item in i.enumVal"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key">
                                </el-option>
                              </el-select>
                          </div> -->
                           </div>
                      
                       <!-- <div class="dome-td  dome-seq"></div>
                      <div class="dome-td">
                       
                        
                      
                      </div>
                      <div class="dome-td">
                           
                      </div>
                      <div class="dome-td" style="width:254px;padding-right:26px">
                       
                       </div> -->
                       <!-- <div class="dome-td" style="display:flex" >
                      
                         <div @click="deleteData(index)" style="color:#0E5FD8;margin-left:20px">删除</div>
                       
                         </div> -->
                      <!-- <div><button @click="remove(index)">移除</button></div> -->
                  </div>
               </el-checkbox-group>
               <div v-else class="noneData" >
                    <div class="noneData-img"></div>
                    暂无数据
               </div>
                  <!-- <div>
                      <div></div>
                      <div><input id="featuresLabel" v-model="user.featuresLabel"></div>
                      <div><input id="featuresValue" v-model="i.value"></div>
                      <div><button @click="insert">添加</button></div>
                  </div> -->
            </div>
        </div> 
         
   </div>  

</template>

<script>

 
export default {
  name: 'HelloWorld',
  props: {
    model: Object,
    getLangMsg: Function,
    invoke: Function,
    rowListDB:Array,
    headListDB:Array,
    selectionList:Array,
    indexDB:[Number,String]
  },
  watch:{
     rowListDB:{
       handler:function(newval,oldval){
             console.log('rowList')
             this.rowList=this.cloneDeepJson(this.rowListDB)
            //  this.initroomSize()          
       },
       deep: true
     },
     headListDB:{
       handler:function(newval,oldval){
             console.log('headList')
             this.headList=this.cloneDeepJson(this.headListDB)
            //  this.initroomSize()          
       },
       deep: true
     },
      selectionList:{
       handler:function(newval,oldval){
            this.rowList[this.indexDB].selectionList=this.selectionList         
       },
       deep: true
     }
     
  },

        created() {
            this.handleToNextStep()
          },
   data(){
     return{
          index:0,  
         checkList:[],
         rowList:[
            //  {'featuresLabel': '张三', 'featuresValue': '',featuresType:'TEXT',selectionList:[]},
            //  {'featuresLabel': '里斯', 'featuresValue':'',featuresType:'DATE',selectionList:[]},
            //  {'featuresLabel': '王五', 'featuresValue':'',featuresType:'SELECT',selectionList:[]},
            //  {'featuresLabel': '王五', 'featuresValue':'',featuresType:'NUMBER',selectionList:[]},
            //   {'featuresLabel': '赵六', 'featuresValue':'',featuresType:'F7',selectionList:[]}
         ],
         typeList:[{
            label:'文本',
            value:'TEXT',
         },{
            label:'数值',
            value:'NUMBER',
         },{
            label:'时间',
            value:'DATE',
         },{
            label:'下拉框',
            value:'SELECT',
         },{
            label:'F7',
            value:'F7',
         }],
         options:[{
          value:'001',
          label:'选项一'
         },{
          value:'002',
          label:'选项二'
         },{
          value:'003',
          label:'选项三'
         }],
         indexList:[]
     }

      },
       methods:{
         keyToLable(Arry,val){
            let label=''
             Arry.forEach(element => {
                if(element.key==val){
                    label=element.value
                }
             });
           return label
         },
       handleToNextStep: function () {
           //调用初始化
            console.log('init_data')
            this.invoke('invokeCustomEvent',{content:{ type: 'init_data', value:''}})    
       },
        cloneDeepJson(obj){
         return JSON.parse(JSON.stringify(obj))
    },
    handleCheckedCitiesChange(checked,key,index) {
         
             let value={
                     key:key,
                     value:checked,
                     index:index
                }
               let parm={content:{ type:'save_data', value:value}}
               console.log('save_data传给后台的参数',parm)
               this.invoke('invokeCustomEvent',parm) 
      },
       // 金额输入校验
        checkNumber(input, index,n) {
          input = input + "";
          input = input.replace(/[^\d.-]/g, ""); // 清除“数字”和“.”"-"以外的字符
          input = input.replace(/\.{2,}/g, "."); // 只保留第一个. 清除多余的
          input = input
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".")
            .replace(/\-{2,}/g, "-"); // 只保留第一个-
          console.log("5555", input);
          // input = input.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
          if (input.indexOf(".") < 0 && input !== "" && input !== "-") {
            // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            input = parseFloat(input);
          }
          // if (parseFloat(input) > 999999999.99) {
          //   input = 999999999.99;
          // }
          this.rowList[index][n].value=input
          // this.$set(this.rowList[index],'featuresValue', input);
        },
       deleteData(index){
         let indexList=[]
         indexList[0]=index
                    let value={
                        indexList:indexList
                     }
                     let parm={content:{ type:'delete_data', value:value}}
                      console.log('delete_data传给后台的参数',parm)
                      this.invoke('invokeCustomEvent',parm)
               
       },
       f7click(index){
               let value={
                    index:index,
                }
               let parm={content:{ type:'f7_click', value:value}}
               console.log('f7_click传给后台的参数',parm)
               this.invoke('invokeCustomEvent',parm) 
       },
       //变更类型，清空数据
       changeType(index,n){
         
          this.saveData(index,n)
       },
       //保存数据
        saveData(index,n){
              let value={
                     key: this.rowList[index][n].key,
                     value:this.rowList[index][n].value,
                     index:index
                }
               let parm={content:{ type:'save_data', value:value}}
               console.log('save_data传给后台的参数',parm)
               this.invoke('invokeCustomEvent',parm) 
       },
       insert:function(){
        //  this.index++;
         let user={
          featuresLabel:'',
          featuresValue:'',
          featuresType:'TEXT'
         }
          // if(index%3==0){
          //   user.featuresType='DATE'
          //   user.featuresLabel='张三2'
          // }
          // if(index%3==1){
          //   user.featuresType='TEXT'
          //   user.featuresLabel='里斯22'
          // }
          // if(index%3==2){
          //   user.featuresType='SELECT'
          //   user.featuresLabel='王五44'
          // }
          this.rowList.push(user)
       },
       remove:function(index){
         this.rowList.splice(index,1)
       }
       
     }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

   .dome-table{
      text-align:left;
      border-top: 1px solid #d9d9d9;
      border-left: 1px solid #d9d9d9;
      border-right: 1px solid #d9d9d9;
     font-size: 12px;
   }

   .dome-tr{
    display:flex;
    border-bottom: 1px solid #d9d9d9;
    font-size:12px;
    min-width:100%;
   }
 
   .noneData{
        width: 100%;
      height: 130px;
      font-size: 12px;
      color: #666;
      text-align: center;
      line-height: 21px;
       border-bottom: 1px solid #d9d9d9;
           padding-top: 8px;
   }
   .noneData-img{
       background: url('../assets/logo.png') no-repeat center;
          width: 100%;
       height: 100px;
   }
   .dome-tr_head{
      color: #333;
      /* border-bottom: 0px solid #d9d9d9 !important; */
      background-color: #f4f4f4;
      min-width:100%;
      height:32px;
      min-height:32px;
      line-height:32px;
      
   }
   .dome-td{
      cursor: pointer;
       /* height:32px; */
      vertical-align:center;
      text-align:left;
      /* padding:4px; */
      line-height:32px;
       width:200px;
     align-items:left;
     padding:4PX 8px;
   }
   .dome-th{
     width:200px;
     align-items:left;
     padding:0 8px;
   }

   .dome-seq{
      width:46px;
      border-right: 1px solid #d9d9d9;
      text-align: center;
      padding:0;
   }
    .dome-seq2{
      width:46px;
      border-right: 1px solid #d9d9d9;
      text-align: center;
      padding: 4px 0 4px 10px;
   }
   .dome-seq3{
      width:46px;
      border-right: 1px solid #d9d9d9;
      text-align: center;
      padding: 4px;
   }
   .dome-input{
    height: 32px !important;
    line-height: 32px !important;


   }

  .dome-td  /deep/ .el-input__inner {
      height: 30px !important;
    line-height: 30px !important;
    text-align: left;
    border-radius:2px !important;
}
.dome-input_F7 /deep/.el-input__inner {
    border-top:0px;
    border-left:0px;
    border-right:0px;
}

 .dome-td  /deep/ .el-input__icon {
    
    line-height: 30px !important;
}

 .dome-td /deep/.el-input-number__decrease{
     bottom: 2px!important;
     line-height: 14px !important;
 }
   .dome-td /deep/.el-input-number__increase{

     line-height: 14px !important;
     top: 2px !important;
 }
 .dome-td /deep/.el-input-number{
  line-height: 32px !important;
  width:200px;
 }
</style>
